/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 *
 *  * Update by  liubaorui on 22/11/14.
 * @desc 添加 removePendingRequest addPendingRequest 处理函数 处理短时间内未响应的重复请求、   encodeURI处理 被url直接携带的特殊字符
 */
import axios from 'axios';
import store from '@/store/';
import router from '@/router/router';
import { serialize } from '@/util/util';
import { getToken } from '@/util/auth';
import { Message } from 'element-ui';
import website from '@/config/website';
import { Base64 } from 'js-base64';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { addPendingRequest, removePendingRequest } from '@/basic-common/util/repetition.js'
// import _ from 'lodash';

//默认超时时间
axios.defaults.timeout = 100 * 1000;
//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/produce';
axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
// NProgress 配置
NProgress.configure({
  showSpinner: false
});
// let refreshLock = false
// const refreshTokenDebounced = _.debounce(() => {
//   if (refreshLock) return;
//   refreshLock = true;
//   store
//     .dispatch('refreshToken')
//     .then(() => {
//       refreshLock = false;
//     })
//     .catch(() => {
//       refreshLock = false;
//     });
// }, 2000);
//http request拦截
axios.interceptors.request.use(config => {
  //判断是否需要鉴权
  // let isAuth = router.history && router.history.current && router.history.current.meta.isAuth;
  // let urls = ['/api/blade-auth/oauth/token', '/api/blade-auth/oauth/logout']
  // if (!urls.includes(config.url) && isAuth !== false) {
  //   // if (config.url != '/api/blade-auth/oauth/token') {
  //   // 不为刷新token的所有接口 参与续约判断，逻辑排除非鉴权借口，不参与非法借口提出登录逻辑
  //   const { refresh_token } = store.getters.userInfo
  //   refresh_token && refreshTokenDebounced()
  // }
  //开启 progress bar
  NProgress.start();
  //headers判断是否需要
  const authorization = config.authorization === false;
  if (!authorization) {
    config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`;
  }

  // 处理get请求 参数被url携带的特殊字符
  // if (config.method === 'get' && config.url.indexOf('?') != -1) {
  //   config.url = encodeURI(config.url)
  // }

  //让每个请求携带token
  const meta = (config.meta || {});
  const isToken = meta.isToken === false;
  if (getToken() && !isToken) {
    config.headers[website.tokenHeader] = 'bearer ' + getToken()
  }
  //headers中配置text请求
  if (config.text === true) {
    config.headers["Content-Type"] = "text/plain";
  }
  //headers中配置serialize为true开启序列化
  if (config.method === 'post' && meta.isSerialize === true) {
    config.data = serialize(config.data);
  }
  config.cancel && removePendingRequest(config); // 检查是否存在重复请求，若存在则取消已发的请求
  config.cancel && addPendingRequest(config); // 把当前请求信息添加到pendingRequest对象中
  return config
}, error => {
  return Promise.reject(error)
});
//http response 拦截
axios.interceptors.response.use(res => {
  //关闭 progress bar
  NProgress.done();
  //获取状态码
  const status = res.data.code || res.status;
  const statusWhiteList = website.statusWhiteList || [];
  const message = res.data.msg || res.data.error_description || '未知错误';
  //如果在白名单里则自行catch逻辑处理
  if (statusWhiteList.includes(status)) return Promise.reject(res);
  //如果是401则跳转到登录页面
  if (status === 401) store.dispatch('FedLogOut').then(() => router.push({ path: '/login' }));
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    Message({
      message: message,
      type: 'error'
    });
    return Promise.reject(new Error(message))
  }
  removePendingRequest(res.config);
  return res;
}, error => {
  NProgress.done();
  removePendingRequest(error.config || {});
  return Promise.reject(new Error(error));
});

export default axios;
